module.exports = __webpack_public_path__ + "0cec698afdc83241a6039fee2213c6ab.png";